<template>
  <div v-if="isShow" class="popFixed">
    <div class="masking" @click="closeBankPop" />
    <div class="tcCon">
      <div class="item">
        <span>温馨提示</span>
        <p>网上存款，需要您提交证明文件后方可使用</p>
      </div>
      <div class="btnCon":class="pageType=='app'?'only':''">
        <span v-if="pageType!='app'" @click="closeBankPop">取消</span>
        <span @click="goPersonalInfo">上传资料</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FirstDeposit',
  props: ['source', 'isFirstDepositPop', 'pageType'],
  data() {
    return {
      isShow: this.isFirstDepositPop
    }
  },
  methods: {
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    closeBankPop() {
      if (this.pageType != 'app') {
        if (this.source == 'home') {
          this.removeFixed()
          this.isShow = false
          this.$emit('changeFirstDepositPop', this.isShow)
        } else {
          this.$router.go(-1)
        }
      }
    },
    goPersonalInfo() {
      this.$bus.$emit('loading', false)
      this.$router.push({ path: '/home/personalInfo' })
    }
  }
}
</script>
